module.exports = function (t) {
  var e = {};
  function n(r) {
    if (e[r]) return e[r].exports;
    var o = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }
  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var o in t) n.d(r, o, function (e) {
      return t[e];
    }.bind(null, o));
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 2);
}([function (t, e) {
  t.exports = require("react");
}, function (t, e, n) {
  t.exports = n(3)();
}, function (t, e, n) {
  "use strict";

  n.r(e);
  var r = n(0),
    o = n.n(r),
    i = n(1),
    u = n.n(i);
  function c(t, e) {
    return function (t) {
      if (Array.isArray(t)) return t;
    }(t) || function (t, e) {
      if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
      var n = [],
        r = !0,
        o = !1,
        i = void 0;
      try {
        for (var u, c = t[Symbol.iterator](); !(r = (u = c.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0);
      } catch (t) {
        o = !0, i = t;
      } finally {
        try {
          r || null == c.return || c.return();
        } finally {
          if (o) throw i;
        }
      }
      return n;
    }(t, e) || function (t, e) {
      if (!t) return;
      if ("string" == typeof t) return a(t, e);
      var n = Object.prototype.toString.call(t).slice(8, -1);
      "Object" === n && t.constructor && (n = t.constructor.name);
      if ("Map" === n || "Set" === n) return Array.from(n);
      if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return a(t, e);
    }(t, e) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
  }
  function a(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
    return r;
  }
  var l = function (t) {
      var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "3",
        n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "#F43059",
        r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "1";
      return {
        margin: 0,
        padding: 0,
        position: "absolute",
        bottom: "-1px",
        right: 0,
        left: 0,
        zIndex: "99",
        backgroundColor: "".concat(n),
        height: "".concat(e, "px"),
        width: "".concat(t),
        transitionProperty: "width",
        transitionDuration: "".concat(r, "s"),
        transitionTimingFunction: "ease-out"
      };
    },
    f = function (t) {
      var e = t.height,
        n = t.bgcolor,
        i = t.duration,
        u = c(Object(r.useState)(0), 2),
        a = u[0],
        f = u[1],
        s = function () {
          var t = document.body.scrollTop || document.documentElement.scrollTop,
            e = document.documentElement.scrollHeight - document.documentElement.clientHeight;
          f(e > 0 ? "".concat(t / e * 100, "%") : 0);
        };
      return Object(r.useEffect)(function () {
        return window.addEventListener("scroll", s), function () {
          window.removeEventListener("scroll", s);
        };
      }, []), o.a.createElement("div", {
        style: l(a, e, n, i)
      });
    };
  f.propTypes = {
    height: u.a.number,
    duration: u.a.number,
    color: u.a.string.isRequired
  }, e.default = f;
}, function (t, e, n) {
  "use strict";

  var r = n(4);
  function o() {}
  function i() {}
  i.resetWarningCache = o, t.exports = function () {
    function t(t, e, n, o, i, u) {
      if (u !== r) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }
    function e() {
      return t;
    }
    t.isRequired = t;
    var n = {
      array: t,
      bool: t,
      func: t,
      number: t,
      object: t,
      string: t,
      symbol: t,
      any: t,
      arrayOf: e,
      element: t,
      elementType: t,
      instanceOf: e,
      node: t,
      objectOf: e,
      oneOf: e,
      oneOfType: e,
      shape: e,
      exact: e,
      checkPropTypes: i,
      resetWarningCache: o
    };
    return n.PropTypes = n, n;
  };
}, function (t, e, n) {
  "use strict";

  t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}]);